import React from "react";
import { Link } from "react-router-dom";
import { Footer, Header } from "../../components";
import { C, FONT, container } from "../../constants/mq";

// Why CS.
//
// Three things, in the order we say them: the courses, the teachers, the
// materials. That is what the franchise brochure leads with and what the
// business actually sells on. The learning system sits under them as the
// thing that ties the three together.
//
// Results belong here as a fourth point and are deliberately absent: there is
// no verified figure to print. Same for testimonials and teacher photos. An
// invented number on this page is worse than a missing one.

const points = [
  {
    no: "01",
    title: "Our courses",
    body: "Every course is written for one year level, not a general ability band, so the work matches what your child is doing at school this term. We write them ourselves and revise them each year against what the tests are actually asking.",
  },
  {
    no: "02",
    title: "Our teachers",
    body: "Experienced teachers who know the syllabus and the exams, in classes small enough that they know each student's strengths and gaps — and can act on them during the lesson rather than at the end of term.",
  },
  {
    no: "03",
    title: "Our materials",
    body: "Our own workbooks, homework sets and trial tests, written to sit alongside the course rather than bought in. Every set is marked and returned, so students see where they went wrong while the topic is still fresh.",
  },
];

// The system the three sit inside. Kept separate because it is the how, not
// one of the three reasons.
const system = {
  title: "The 7-Step Learning System",
  body: "Assessment, teaching, study, homework, tutoring, consulting and a class test — the same seven steps every term, on campus and online, all recorded in one place so parents can see where their child is up to.",
};

// Red banner like CommonBanner on top; everything below sits on white, with
// the learning system as a sand box rather than a second red block.
const s = {
  hero: {
    background: `linear-gradient(112deg, ${C.bright} 0%, ${C.bright} 66%, #C2001A 66%, #C2001A 100%)`,
    color: "#fff",
    padding: "58px 0 54px",
    fontFamily: FONT,
  },
  container,
  eyebrow: {
    display: "inline-block", fontSize: 12.5, fontWeight: 600, letterSpacing: "1.2px",
    textTransform: "uppercase", color: "rgba(255,255,255,0.85)", margin: "0 0 14px",
  },
  h1: {
    fontSize: 40, fontWeight: 800, letterSpacing: "-0.5px", margin: 0, lineHeight: 1.18,
    color: "#fff", maxWidth: 680,
  },
  lead: { fontSize: 15.5, lineHeight: 1.65, color: "rgba(255,255,255,0.92)", margin: "14px 0 0", maxWidth: 620 },
  body: { padding: "64px 0 80px", background: "#fff", fontFamily: FONT },
  grid: {
    display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 24,
  },
  card: { padding: "24px 22px 26px" },
  cardNo: {
    display: "block", fontSize: 13, fontWeight: 800, letterSpacing: "1px",
    color: C.bright, marginBottom: 10,
  },
  cardTitle: { fontSize: 19, fontWeight: 700, color: C.ink, margin: "0 0 8px" },
  systemCard: { marginTop: 28, padding: "26px 28px" },
  systemTitle: { fontSize: 19, fontWeight: 700, color: C.ink, margin: "0 0 8px" },
  systemBody: { fontSize: 14.5, lineHeight: 1.7, color: C.body, margin: "0 0 16px", maxWidth: 720 },
  cardBody: { fontSize: 14, lineHeight: 1.65, color: C.body, margin: 0 },
  ctaRow: { display: "flex", flexWrap: "wrap", alignItems: "center", gap: "16px 32px", marginTop: 40 },
};

const WhyCs = () => (
  <div style={{ background: "#fff" }}>
    <Header />
    <main>
      <section style={s.hero}>
        <div style={s.container}>
          <span style={s.eyebrow}>Why CS Education</span>
          <h1 style={s.h1}>Three reasons families stay</h1>
          <p style={s.lead}>
            We have run our own programs since 2002, Kindergarten to the HSC,
            on campus and online. It comes down to three things.
          </p>
        </div>
      </section>

      <section style={s.body}>
        <div style={s.container}>
          <div style={s.grid}>
            {points.map((p) => (
              <div key={p.title} className="mq-card mq-card--hover" style={s.card}>
                <span style={s.cardNo}>{p.no}</span>
                <h2 style={s.cardTitle}>{p.title}</h2>
                <p style={s.cardBody}>{p.body}</p>
              </div>
            ))}
          </div>

          <div className="mq-sand" style={s.systemCard}>
            <h2 style={s.systemTitle}>{system.title}</h2>
            <p style={s.systemBody}>{system.body}</p>
            <Link to="/our-courses" className="mq-link">
              See how a term runs
            </Link>
          </div>

          <div style={s.ctaRow}>
            <Link className="mq-btn" to="/enroll">
              Enrol now
            </Link>
            <Link className="mq-link" to="/our-courses">
              Browse courses
            </Link>
            <Link className="mq-link" to="/contact-us">
              Talk to us
            </Link>
          </div>
        </div>
      </section>
    </main>
    <Footer />
  </div>
);

export default WhyCs;
